import {
    convertUniversalDateTimeToPersianDateTime,
    RaikoBaseCardContainer, RaikoCreatorInfo,
    RaikoGridOneColumn, RaikoGridTwoColumn,
    RaikoSectionContainer,
    RaikoSimpleInputOutlined, showServerErrorMessage, showSuccessMessage
} from "@moeindal/base-raiko-panel-components";
import React, {useEffect, useRef, useState} from "react";
import {LoadingHelper} from "../../../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../../../context/LoadingContext";

export default function PredefinedAvatarDetailsBasicInfo({service, predefinedAvatarId}) {


    const [title, setTitle] = useState("");
    const [slug, setSlug] = useState("");
    const [actionButtonLoading, setActionButtonLoading] = useState(false);
    const [createdBy, setCreatedBy] = useState("");
    const [createdAt, setCreatedAt] = useState("");

    const loading = new LoadingHelper(useLoadingDispatcher())

    useEffect(() => {
        if (typeof service !== "undefined") {
            getPredefinedAvatarBasicInfoFromServer()
        }
    }, [predefinedAvatarId]);

    function getPredefinedAvatarBasicInfoFromServer() {
        loading.show()
        service.getPredefinedAvatarBasicInfo(predefinedAvatarId, title, slug)
            .then(response => {
                setTitle(response.title)
                setSlug(response.slug)
                setCreatedBy(response.createdBy)
                setCreatedAt(convertUniversalDateTimeToPersianDateTime(response.createdAt))
            }).catch(reason => {
            showServerErrorMessage(reason)
        }).finally(_ => {
            loading.hide()
        })
    }


    function handleUpdatePredefinedAvatarBasicInfo() {
        setActionButtonLoading(true)
        service.updatePredefinedAvatarBasicInfo(predefinedAvatarId, title, slug)
            .then(response => {
                showSuccessMessage("بروزرسانی با موفقیت انجام شد.")
            }).catch(reason => {
            showServerErrorMessage(reason)
        }).finally(_ => {
            setActionButtonLoading(false)
        })
    }


    return (
        <RaikoGridOneColumn>
            <RaikoBaseCardContainer>
                <RaikoSectionContainer
                    title={"اطلاعات پایه"}
                    hasActionButton
                    actionButtonOnclickWithValidation={handleUpdatePredefinedAvatarBasicInfo}
                    actionButtonLoadingState={actionButtonLoading}
                >
                    <RaikoGridTwoColumn>
                        <RaikoSimpleInputOutlined
                            labelText={"عنوان"}
                            value={title}
                            setValue={setTitle}
                            required
                        />
                        <RaikoSimpleInputOutlined
                            labelText={"slug"}
                            value={slug}
                            setValue={setSlug}
                            required
                        />
                    </RaikoGridTwoColumn>
                </RaikoSectionContainer>
            </RaikoBaseCardContainer>
            <RaikoCreatorInfo createdBy={createdBy} createdAt={createdAt}/>
        </RaikoGridOneColumn>
    )
}